import './style.scss';


export function related_resources_block() {

    const block = document.querySelector('.related_resources_block');
    if (!block) return;

}
